import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { MessageService } from '@services/message/message.service';

@Component({
  selector: 'app-email-confirmation',
  templateUrl: './email-confirmation.component.html',
  styleUrls: ['./email-confirmation.component.scss']
})
export class EmailConfirmationComponent implements OnInit {

  @ViewChild('successMessage') successMessage: TemplateRef<any>;

  currentYearLong(): number {
    return new Date().getFullYear();
  }

  constructor(private authenticationService: AuthenticationService, private route: ActivatedRoute, public messageService: MessageService) { }

  ngOnInit(): void {
    this.confirmEmail();
  }

  confirmEmail() {
    const token = this.route.snapshot.queryParams['token'];
    const email = this.route.snapshot.queryParams['email'];

    this.authenticationService.confirmEmail(token, email)
      .subscribe(_ => {
        this.messageService.setSuccess(this.successMessage);
      },
        error => {
          this.messageService.setError(error);
        })
  }
}
